// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"408":"crawls-home","681":"crawl-single"}[chunkId] + "." + {"408":"5123450a","681":"85785fd7"}[chunkId] + ".js";
};